import React from 'react';
import styles from './WhyWorkWithUs.module.css';

const WhyWorkWithUs = () => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>Work With Us</h2>

        <p className={styles.subtitle}>
          Global Expertise. Local Cost Advantage.
        </p>

        <p className={styles.text}>
          At <strong>BETA Edge</strong>, all services are billed exclusively in
          <strong> Indian Rupees(INR)</strong> helping you avoid currency
          volatility, rising international trade costs and tariff-driven
          pricing uncertainties.
        </p>

        <ul className={styles.list}>
          <li>INR based billing with transparent pricing</li>
          <li>Protection from foreign exchange fluctuations</li>
          <li>Cost efficiency without compromising quality</li>
          <li>Predictable budgeting for long-term projects</li>
        </ul>

        <p className={styles.footerText}>
          In a shifting global trade environment, partnering with an India-based
          team enables organizations to maintain operational excellence while
          managing costs effectively.
        </p>

        <p className={styles.brandLine}>
          <strong>BETA Edge</strong> delivers stability, scalability and value 
          without international pricing pressures.
        </p>
      </div>
    </section>
  );
};

export default WhyWorkWithUs;
